define('app/cookie-policy',['jquery-private', 'jquery.cookie'], function($, cookie) {
	
	var cookie_data = $.cookie('octagon-data-cookies'),
		notification = $('#cookie-notification'),
		btn = $('.btn', notification);

	if ( !cookie_data ) {
		// Show notification
		notification.removeClass('hide');

		// Hide on confirm
		btn.on('click', function() {
			// Hide notification
			notification.slideUp(250, function() {
				$(this).remove();
			});

			// Set cookie
			$.cookie('octagon-data-cookies', true, {expires: 365});
		});
	} else {
		// Remove notification
		notification.remove();
	}

});
